import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Heart, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep polling */ }
      if (attempts >= 8) { setStatus("pending"); return; }
      setTimeout(poll, 1800);
    };
    poll();
  }, [sessionId]);

  return (
    <main className="min-h-screen bg-navy-900 flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl p-10 max-w-md w-full text-center shadow-2xl">
        {status === "checking" && <><Loader2 className="h-14 w-14 text-navy-900 animate-spin mx-auto mb-5" /><h1 className="font-display text-2xl font-bold text-navy-900">Confirming your donation...</h1></>}
        {status === "paid" && <>
          <div className="h-20 w-20 rounded-full bg-verified/10 flex items-center justify-center mx-auto mb-5"><CheckCircle2 className="h-12 w-12 text-verified" /></div>
          <h1 className="font-display text-3xl font-bold text-navy-900">Thank you!</h1>
          <p className="text-slate-600 mt-3">Your {info?.frequency === "monthly" ? "monthly" : "one-time"} gift of <strong>${info?.amount}</strong> helps open doors across our community.</p>
        </>}
        {status === "pending" && <><Loader2 className="h-14 w-14 text-gold animate-spin mx-auto mb-5" /><h1 className="font-display text-2xl font-bold text-navy-900">Processing your donation</h1><p className="text-slate-600 mt-3">This is taking a moment. Your receipt will arrive by email once confirmed.</p></>}
        {status === "error" && <><h1 className="font-display text-2xl font-bold text-navy-900">We couldn't confirm this payment</h1><p className="text-slate-600 mt-3">If you were charged, please contact us and we'll help right away.</p></>}
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link to="/"><Button className="rounded-full bg-navy-900 hover:bg-navy-700 text-white"><Home className="h-4 w-4 mr-2" /> Home</Button></Link>
          <Link to="/donate"><Button variant="outline" className="rounded-full"><Heart className="h-4 w-4 mr-2" /> Donate Again</Button></Link>
        </div>
      </div>
    </main>
  );
}
